
  <div class="container">
    <div class="col-12 text-center"><img src="../../../assets/images/emblem.png" class="emblem" /></div>
    <br />
    <p class="text-center">Thank you for contacting us. One of our representatives will get in touch with you.<br />In the meantime, please continue browsing our website.</p>
  </div>

